import { CityCollectionRO } from '@routellers/types/dist/city-collection/city-collection.ro';
import { UpsertCityCollectionDto } from '@routellers/types/dist/city-collection/upsert-city-collection.dto';
import { CityCollectionKindEnum } from '@routellers/types/dist/city-collection/city-collection-kind.enum';
import { QueryDto } from '@routellers/types/dist/shared/query.dto';
import { QueryRO } from '@routellers/types/dist/shared/query.ro';

import { ApiMethodDeclaration } from '..';

const kinds: ApiMethodDeclaration<void, Array<{ kind: CityCollectionKindEnum; slug: string }>> =
    () => ({
        url: '/admin/city-collections/kinds',
        method: 'GET',
    });

const query: ApiMethodDeclaration<QueryDto, QueryRO<CityCollectionRO>> = (params) => ({
    url: '/admin/city-collections',
    method: 'GET',
    params,
});

const getOne: ApiMethodDeclaration<number, CityCollectionRO> = (id) => ({
    url: `/admin/city-collections/${id}`,
    method: 'GET',
});

const upsert: ApiMethodDeclaration<{ data: UpsertCityCollectionDto }, CityCollectionRO> = ({
    data,
}) => ({
    url: '/admin/city-collections',
    method: 'POST',
    data,
});

export const cityCollectionsApiDeclaration = {
    kinds,
    query,
    getOne,
    upsert,
};
